<template>
  <div id="app">
    <HeaderComponent />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import HeaderComponent from './components/HeaderComponent'
import Footer from './components/Footer'
export default {
  components: { HeaderComponent, Footer }
}
</script>

<style lang="scss">
body {
  // background: url('./assets/szablon.jpg') top center !important;
}

@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,600i,700&display=swap&subset=latin-ext');
@import url('https://fonts.googleapis.com/css?family=Roboto:300display=swap');
@import url('https://fonts.googleapis.com/css?family=Asap&display=swap');

@import './myVariables.scss';
@import '../node_modules/foundation-sites/scss/foundation.scss';
@include foundation-flex-grid;
@include foundation-everything();

.logo {
  width: 88px;
  @media (max-width: map-get($breakpoints, large) - 1) {
    width: 68px;
  }
}
.top-bar-right .menu a {
  color: white;
  font-size: 24px;
  height: 100%;
  display: flex;
  align-items: center;
  transition: all 300ms ease;
  &.active {
    background: $primary-color;
  }
  &:hover {
    background: rgba($primary-color, 0.8);
  }
  @media (max-width: map-get($breakpoints, large) - 1) {
    font-size: 20px;
  }
  @media (max-width: map-get($breakpoints, medium) - 1) {
    width: 100vw;
    padding: 20px;
  }
}
.menu-text {
  font-size: 34px;
  color: white !important;
  letter-spacing: -0.9px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300 !important;
  strong {
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
  }
  @media (max-width: map-get($breakpoints, large) - 1) {
    font-size: 24px;
    padding: 10px !important;
  }
  @media (max-width: 500px) {
    font-size: 20px;
    padding: 0px !important;
  }
}
.top-bar {
  height: 110px;
  @media (max-width: map-get($breakpoints, large) - 1) {
    height: 90px;
    padding-right: 0;
    padding-left: 0;
  }
}
.top-bar-right {
  height: 100%;
  display: flex;
  margin-right: 30px;
  @media (max-width: map-get($breakpoints, medium) - 1) {
    position: absolute;
    width: 100vw;
    top: 90px;
    left: 0;
    display: flex;
    flex-direction: column;
    z-index: 1;
    height: auto;
    opacity: 0;
    transition: all 300ms ease;
    overflow-x: hidden;
  }
}
.hamburger {
  position: absolute;
  top: 15px;
  right: 25px;
  color: white;
  font-size: 34px;
  cursor: pointer;
}
.showMenu {
  opacity: 1;
}
@keyframes jumboFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.jumbo {
  padding: 30px 60px;
  background: url('./assets/jumbo.jpg');
  animation: jumboFadeIn 1300ms ease;
  background-position: 0px -300px;
  min-height: 700px;
  width: 100%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .orange {
    background: $primary-color;
    color: white;
    padding: 43px 80px 40px;
    max-width: 730px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.8;
    flex-direction: column;
    @media (max-width: map-get($breakpoints, medium) - 1) {
      padding: 20px 30px;
    }
    .orange__phone {
      font-family: 'Asap', sans-serif;
      font-size: 48px;
      transition: all 300ms ease;
      @media (max-width: map-get($breakpoints, medium) - 1) {
        font-size: 28px;
      }
    }
    .orange__text {
      font-weight: 600;
      font-style: italic;
      text-align: center;
    }
  }
  @media (max-width: 1650px) {
    background-position: 0px -100px;
  }
  @media (max-width: map-get($breakpoints, xlarge) - 1) {
    min-height: 650px;
  }
  @media (max-width: map-get($breakpoints, large) - 1) {
    min-height: 500px;
    background-position: center center;
  }
  @media (max-width: map-get($breakpoints, medium) - 1) {
    min-height: 300px;
    padding: 25px;
  }
}
.about {
  padding: 0 15px;
}
.icon_spacer {
  flex: 1 0 15px;
}
.myCard {
  margin-bottom: 25px;
}

.myCard__icon i {
  background: #374047;
  font-size: 50px;
  color: white;
  border: 25px solid #374047;
  border-radius: 50px;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
}
.myCard__text {
  padding: 0 20px;
  font-size: 14px;
  p {
    line-height: 23px;
  }
}
.spacer {
  height: 80px;
  width: 100%;
}
.spacer2 {
  height: 55px;
  width: 100%;
}
h2 {
  text-align: center;
}
p.afterH2 {
  width: 60%;
  font-size: 17px;
  letter-spacing: -0.1px;
  text-align: center;
  line-height: 24px;
  color: #a0a0a0;
  @media (max-width: map-get($breakpoints, medium) - 1) {
    width: 100%;
    text-align: justify;
  }
}
.myCard h3 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.text-section {
  padding: 60px 30px 80px;
  @media (max-width: map-get($breakpoints, medium) - 1) {
    padding: 60px 25px 80px;
  }
}
.what-we-do {
  color: white;
  background: url('./assets/dzieci.jpg') center center;
  background-size: cover;
  margin-top: 30px;
}
p.content {
  text-align: center;
  margin: 30px 0;
  font-size: 18px;
  font-weight: 300;
  width: 75%;
  line-height: 26px;
  @media (max-width: map-get($breakpoints, medium) - 1) {
    padding: 30px 0px 40px;
    text-align: justify;
    width: 100%;
    margin: 0;
  }
}
h6 {
  color: $primary-color;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
</style>
